import { gql } from '@apollo/client'

export default gql`
  query trucksListQuery(
    $marketId: Int!
    $trucksOffset: Int
    $trucksLimit: Int
  ) {
    market(id: $marketId) {
      id
      name
      customerTrucksListPath
      trucks {
        total
      }
      popularTrucks(page: { limit: $trucksLimit, offset: $trucksOffset }) {
        records {
          id
          name
          scheduleUrl
          menus {
            id
            foodTypes {
              id
              name
            }
          }
          foodImage {
            medium
          }
          ratingInfo {
            averageRating
            ratingsCount
          }
        }
      }
    }
  }
`
